
Greenmile.EventNotifications = Greenmile.EventNotifications || {};
Greenmile.EventNotifications.Stop = Greenmile.EventNotifications.Stop || {};
Greenmile.EventNotifications.Stop.TableView = Greenmile.EventNotifications.Stop.TableView || {};

Greenmile.EventNotifications.Stop.TableView = (function () {

    function StopTableView (stop) {

        this.getStopTabContent = function () {

            var allContent = document.createElement('div');
            var divLocation = this.getLocationContent();

            var divStop = document.createElement('div');
            divStop.className = 'stopTableViewStopData';

            divStop.appendChild(this.getStopContent());

            var deliveryContent = this.getDeliveryContent();
            if (deliveryContent) {
                divStop.appendChild(deliveryContent);
            }

            var pickupContent = this.getPickupContent();
            if (pickupContent) {
                divStop.appendChild(pickupContent);
            }

            var twContent = this.getTimeWindowContent();
            if (twContent) {
                divStop.appendChild(twContent);
            }

            allContent.appendChild(divLocation);
            allContent.appendChild(divStop);

            return allContent;
        };

        var getViewSizeContent = function (info, className, resourceId) {
            if (info.length > 0) {

                var div = document.createElement('div');
                div.className = className;
                var divHeader = document.createElement('div');
                divHeader.className = 'EventNotificationTabHeader';
                divHeader.innerHTML = Monet.I18n.getResourcesByKey(resourceId);
                div.appendChild(divHeader);

                var grid = new Greenmile.UI.SizesTableView(info);
                div.appendChild(grid.render());

                return div;
            }

            return null;
        };

        this.getDeliveryContent = function () {

            var info = [];

            if (stop.plannedSize1 || stop.actualSize1) {
                info.push({
                    label: 'notificationPanel.size1',
                    planned: stop.plannedSize1,
                    actual: stop.actualSize1
                });
            }

            if (stop.plannedSize2 || stop.actualSize2) {
                info.push({
                    label: 'notificationPanel.size2',
                    planned: stop.plannedSize2,
                    actual: stop.actualSize2
                });
            }

            if (stop.plannedSize3 || stop.actualSize3) {
                info.push({
                    label: 'notificationPanel.size3',
                    planned: stop.plannedSize3,
                    actual: stop.actualSize3
                });
            }

            return getViewSizeContent(info, 'stopTableViewDeliveryData', 'EventNotifications.Delivery');
        };

        this.getPickupContent = function () {

            var info = [];

            if (stop.plannedPickupSize1 || stop.actualPickupSize1) {
                info.push({
                    label: 'notificationPanel.size1',
                    planned: stop.plannedPickupSize1,
                    actual: stop.actualPickupSize1
                });
            }

            if (stop.plannedPickupSize2 || stop.actualPickupSize2) {
                info.push({
                    label: 'notificationPanel.size2',
                    planned: stop.plannedPickupSize2,
                    actual: stop.actualPickupSize2
                });
            }

            if (stop.plannedPickupSize3 || stop.actualPickupSize3) {
                info.push({
                    label: 'notificationPanel.size3',
                    planned: stop.plannedPickupSize3,
                    actual: stop.actualPickupSize3
                });
            }

            return getViewSizeContent(info, 'stopTableViewPickupData', 'EventNotifications.Pickup');


        };

        this.getLocationContent = function () {

            var location = stop.location;
            var divLocation = document.createElement('div');
            var divKey = document.createElement('div');
            var divAddress = document.createElement('div');
            var divPhone = document.createElement('div');

            divLocation.className = 'EventNotificationTabHeader stopTableViewLocationData';
            divKey.className = 'locationKeyName';

            divAddress.className = 'locationAddress';
            divPhone.className = 'locationPhone';

            if (location) {
                var locationModel = new App.Models.Location(location);
                var addressFormatted = locationModel.getItemsOfAddress();

                divKey.innerHTML = location.key + (location.description ? ' - ' + location.description : '');
                divAddress.innerHTML = addressFormatted.join(", ");

                var phones = [];
                if (location.phone1) {
                    phones.push(location.phone1);
                }
                if (location.phone2) {
                    phones.push(location.phone2);
                }

                divPhone.innerHTML = phones.join(", ");

            } else {
                var type = stop.stopType.type ? Monet.I18n.getResourcesByKey(stop.stopType.type) : '';
                divKey.innerHTML = Monet.I18n.translateResources('EventNotification.noLocationFound', { stopType: type });
            }

            divLocation.appendChild(divKey);
            divLocation.appendChild(divAddress);
            divLocation.appendChild(divPhone);

            return divLocation;
        };

        this.getStopContent = function () {
            var info = [getArrivalLine(),
                getDepartLine(),
                getServiceTimeLine()
            ];

            var grid = new Greenmile.UI.TimeTableView(info);
            return grid.render();
        };

        this.getTimeWindowContent = function () {

            var allContent = null;
            var location = stop.location;
            var timeWindows = null;

            if (location) {
                var twFunctions = new Greenmile.TimeWindow.GeneralFunctions();
                timeWindows = twFunctions.getTimeWindow(location);
            }

            if (timeWindows && timeWindows.length > 0) {

                var eventNotificationOc = Monet.I18n.getResourcesByKey('EventNotification.openClose');
                var eventNotificationTw = Monet.I18n.getResourcesByKey('EventNotification.timeWindow');
                var windowLabel = document.createElement('div');
                var tableView = new Monet.UI.TableView();
                var lines = { data: [] };

                allContent = document.createElement('div');

                windowLabel.className = 'EventNotificationTabHeader';
                windowLabel.innerHTML = Monet.I18n.getResourcesByKey('EventNotification.timeWindows');

                tableView.setHeaders(['', eventNotificationOc, eventNotificationTw]);

                for (var i = 0, length = timeWindows.length; i < length; i++) {

                    var window = timeWindows[i];
                    var days = window.days;

                    for (var k = 0, daysLength = days.length; k < daysLength; k++) {
                        days[k] = Monet.I18n.getResourcesByKey(days[k]);
                    }

                    lines.data.push(
                        [new Monet.UI.TableViewCell('TEXT', days.join(", ")),
                            new Monet.UI.TableViewCell('TEXT', window.openClose),
                            new Monet.UI.TableViewCell('TEXT', window.timeWindow)
                        ]
                    );

                }

                tableView.setLines(lines);

                allContent.appendChild(windowLabel);
                allContent.appendChild(tableView.render());
            }

            return allContent;
        };

        function getArrivalLine () {

            return {
                label: 'notificationPanel.arrive',
                planned: stop.plannedArrival,
                projected: stop.projectedArrival,
                actual: stop.actualArrival
            };
        }

        function getDepartLine () {

            return {
                label: 'notificationPanel.depart',
                planned: stop.plannedDeparture,
                projected: stop.projectedDeparture,
                actual: stop.actualDeparture
            };
        }

        function getServiceTimeLine () {

            return {
                label: 'notificationPanel.service',
                planned: stop.plannedService,
                projected: stop.projectedService,
                actual: stop.actualService
            };
        }

    }

    return StopTableView;

})();

